<div class="filter-table">
  @switch (fieldType) {
    @case ('options') {
      <div>
        <div
          class="dropdown"
      [ngClass]="{
        'background-color': app.filter.isSelected(
          fieldId,
          app.filterHeaderTable.filters
        )
      }"
          >
          <input
            class="form-control dropdown-filter dropdown-toggle"
            data-bs-toggle="dropdown"
            onkeydown="return false"
        placeholder="{{
          app.filter.isSelected(fieldId, app.filterHeaderTable.filters)
            ? app.text.RM.filterApplied
            : app.text.RM.filter
        }}"
            (click)="app.filterTable.isDropdownOpen = true"
            />
          @if (app.filter.isSelected(fieldId, app.filterHeaderTable.filters)) {
            <button
              class="btn clear-dropdown"
              >
              <i class="fa fa-times icon-size" (click)="clearFilter(fieldId)"></i>
            </button>
          }
          <div class="dropdown-menu dropdown-list">
            @for (option of app.filterTable.getOptions(fieldId); track option) {
              <div>
                <label class="checkbox-label" (click)="$event.stopPropagation()">
                  <input
                    #checkboxes
                    type="checkbox"
                    class="checkbox-input"
                    value="{{ option }}"
              [checked]="
                app.filter.isChecked(
                  fieldId,
                  option,
                  app.filterHeaderTable.filters
                )
              "
              (click)="
                $event.stopPropagation();
                app.filterHeaderTable.filter(fieldId, option);
                closeDropdown()
              "
                    />
                  <span class="label">{{
                    app.filterTree.getOptionText(fieldId, option)
                  }}</span>
                </label>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <!-- when the type of the field is input -->
    @case ('value') {
      <div>
        <div
          class="input-group"
      [ngClass]="{
        'background-color': model[fieldId] != null && model[fieldId] !== ''
      }"
          >
          <input
            type="text"
            class="form-control input-filter"
            [(ngModel)]="model[fieldId]"
            (keydown)="checkKey($event, fieldId, model[fieldId])"
            placeholder="{{ app.text.RM.filter }}"
            (click)="app.filterTable.isDropdownOpen = false"
            />
          @if (model[fieldId]) {
            <button
              class="btn btn-sm p-1"
              (click)="clearFilter(fieldId)"
              >
              <i class="fa fa-times"></i>
            </button>
          }
          <button class="btn btn-sm p-1">
            <i
              class="fa fa-search"
              (click)="app.filterHeaderTable.filter(fieldId, model[fieldId])"
            ></i>
          </button>
        </div>
      </div>
    }
    @case ('typeahead') {
      <div>
        <div
          class="input-group typeahead-wrapper"
      [ngClass]="{
        'background-color': model[fieldId] != null && model[fieldId] !== ''
      }"
          >
          <app-field
            [model]="model"
            [field]="fieldId"
            [showLabel]="false"
            [showMandatory]="true"
            [typeaheadPlaceholder]="app.text.RM.filter"
            >
          </app-field>
          @if (!app.filter.isSelected(fieldId, app.filterHeaderTable.filters)) {
            <i
              class="fa fa-search typeahead-search-icon"
              (click)="searchTypeahead(fieldId)"
            ></i>
          }
        </div>
      </div>
    }
    @case ('dateInterval') {
      <div>
        <div
          class="dropdown"
      [ngClass]="{
        'background-color': app.filter.isSelected(
          fieldId,
          app.filterHeaderTable.filters
        )
      }"
          >
          <input
            type="text"
            class="form-control input-filter"
            readonly
        placeholder="{{
          app.filter.dateFilterIsSelected(fieldId)
            ? app.text.RM.filterApplied
            : app.text.RM.filter
        }}"
            (click)="openDatePicker(fieldId, $event)"
            />
          @if (app.filter.dateFilterIsSelected(fieldId)) {
            <button
              class="btn clear-dropdown"
              >
              <i
                class="fa fa-times icon-size"
                (click)="clearDateFilter(fieldId)"
              ></i>
            </button>
          }
        </div>
      </div>
    }
  }
</div>
